module.exports = __webpack_public_path__ + "static/media/041-St. Hubert.8c0f11d8.jpg";